module.exports = __webpack_public_path__ + "static/media/resources.3893dbc2.svg";